var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm.error
        ? _c(
            "b-alert",
            {
              ref: "errorAlert",
              attrs: {
                tabindex: "-1",
                show: "",
                variant: "danger",
                role: "alert",
              },
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitUpload.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Emerald export (CSV)",
                        "label-for": "registry-upload-file",
                        description: _vm.uploadLimitDescription,
                      },
                    },
                    [
                      _c("b-form-file", {
                        attrs: {
                          id: "registry-upload-file",
                          disabled: !_vm.canUpdate || _vm.busy,
                          accept: ".csv,text/csv",
                          state: _vm.uploadFileError ? false : null,
                        },
                        model: {
                          value: _vm.uploadForm.file,
                          callback: function ($$v) {
                            _vm.$set(_vm.uploadForm, "file", $$v)
                          },
                          expression: "uploadForm.file",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        {
                          attrs: { state: _vm.uploadFileError ? false : null },
                        },
                        [_vm._v(_vm._s(_vm.uploadFileError))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-link",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.registry-import-details",
                          modifiers: { "registry-import-details": true },
                        },
                      ],
                      staticClass: "d-inline-block mb-2",
                    },
                    [_vm._v("Additional details (optional)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    { attrs: { id: "registry-import-details" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Dataset kind",
                            "label-for": "registry-upload-dataset_kind",
                            description:
                              "Detected from headers. Choose a kind to check it matches.",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "registry-upload-dataset_kind",
                              disabled: !_vm.canUpdate || _vm.busy,
                              options: _vm.datasetKindOptions,
                            },
                            model: {
                              value: _vm.uploadForm.dataset_kind,
                              callback: function ($$v) {
                                _vm.$set(_vm.uploadForm, "dataset_kind", $$v)
                              },
                              expression: "uploadForm.dataset_kind",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Source export date/time",
                            "label-for": "registry-upload-declared_export_at",
                            description:
                              "Optional. Warns if an applied export is newer. Apply order determines precedence.",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "registry-upload-declared_export_at",
                                  disabled: !_vm.canUpdate || _vm.busy,
                                  type: "datetime-local",
                                  step: "1",
                                },
                                model: {
                                  value: _vm.uploadForm.declared_export_at,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.uploadForm,
                                      "declared_export_at",
                                      $$v
                                    )
                                  },
                                  expression: "uploadForm.declared_export_at",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticClass: "registry-timezone",
                                attrs: {
                                  "aria-label": "Source export timezone",
                                  disabled: !_vm.canUpdate || _vm.busy,
                                  options: _vm.timezoneOptions,
                                },
                                model: {
                                  value:
                                    _vm.uploadForm.declared_export_timezone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.uploadForm,
                                      "declared_export_timezone",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "uploadForm.declared_export_timezone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Scope notes",
                            "label-for": "registry-upload-scope_notes",
                            description:
                              "Plain text, e.g. “Colorado, all statuses, partition 2 of 5”.",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "registry-upload-scope_notes",
                              disabled: !_vm.canUpdate || _vm.busy,
                              rows: "2",
                              maxlength: "2000",
                            },
                            model: {
                              value: _vm.uploadForm.scope_notes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.uploadForm,
                                  "scope_notes",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "uploadForm.scope_notes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            disabled:
                              _vm.busy ||
                              !_vm.uploadForm.file ||
                              !_vm.canUpdate ||
                              !!_vm.uploadFileError,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Validate for review\n                    "
                          ),
                          _vm.uploading
                            ? _c("b-spinner", {
                                staticClass: "ml-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted d-block mt-2" }, [
                    _vm._v(
                      "Validate first, then review and apply. Validation does not change registry records."
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { lg: "8" } },
            [
              _vm.review
                ? _c(
                    "b-card",
                    { staticClass: "registry-import-review" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-start mb-2",
                        },
                        [
                          _c("div", [
                            _c("h5", { staticClass: "mb-0" }, [
                              _vm._v(
                                "Batch #" +
                                  _vm._s(_vm.review.batch_id) +
                                  " · " +
                                  _vm._s(_vm.review.original_file_name)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.labelize(_vm.review.dataset_kind)) +
                                  " export · uploaded by " +
                                  _vm._s(
                                    _vm.review.initiated_by_email ||
                                      _vm.review.initiated_by_user_id ||
                                      "System"
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-right" },
                            [
                              _c(
                                "b-badge",
                                {
                                  attrs: {
                                    variant: _vm.phaseVariant(_vm.review.phase),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.phaseLabel(_vm.review.phase))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "p-0 ml-2",
                                  attrs: {
                                    size: "sm",
                                    variant: "link",
                                    disabled: _vm.busy,
                                  },
                                  on: { click: _vm.closeReview },
                                },
                                [_vm._v("Close")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.reviewNotice
                        ? _c(
                            "b-alert",
                            {
                              staticClass: "py-2",
                              attrs: {
                                show: "",
                                variant: _vm.reviewNotice.variant,
                              },
                            },
                            [_vm._v(_vm._s(_vm.reviewNotice.text))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "small mb-2" }, [
                        _vm._v(
                          _vm._s(_vm.readable(_vm.phaseDescription(_vm.review)))
                        ),
                      ]),
                      _vm.reviewError
                        ? _c(
                            "b-alert",
                            { attrs: { show: "", variant: "danger" } },
                            [
                              _vm._v(_vm._s(_vm.reviewError) + " "),
                              _c(
                                "b-btn",
                                {
                                  attrs: { size: "sm", variant: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.loadReview(_vm.review.batch_id)
                                    },
                                  },
                                },
                                [_vm._v("Retry")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "dl",
                        { staticClass: "row small mb-2" },
                        [
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v("Kind"),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-sm-8" }, [
                            _vm._v(
                              _vm._s(_vm.labelize(_vm.review.dataset_kind))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v("Rows in file"),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-sm-8" }, [
                            _vm._v(
                              _vm._s(
                                _vm.review.row_count === null
                                  ? "?"
                                  : _vm.review.row_count
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v("Skipped at validation"),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-sm-8" }, [
                            _vm._v(_vm._s(_vm.review.counts.skipped)),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v("States in file"),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-sm-8" }, [
                            _vm._v(_vm._s(_vm.observedStates(_vm.review))),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v("Source export time"),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-sm-8" }, [
                            _vm._v(
                              _vm._s(
                                _vm.review.declared_export_at_local ||
                                  "Not supplied"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v("Scope notes"),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-sm-8 registry-notes" }, [
                            _vm._v(
                              _vm._s(
                                _vm.readable(_vm.scopeNotes(_vm.review)) ||
                                  "None"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.review.accepted_sequence
                            ? [
                                _c("dt", { staticClass: "col-sm-4" }, [
                                  _vm._v("Applied"),
                                ]),
                                _vm._v(" "),
                                _c("dd", { staticClass: "col-sm-8" }, [
                                  _vm._v(
                                    "\n                      sequence " +
                                      _vm._s(_vm.review.accepted_sequence) +
                                      " · " +
                                      _vm._s(
                                        _vm.formatDate(_vm.review.accepted_at)
                                      ) +
                                      "\n                      "
                                  ),
                                  _vm.review.accepted_by_email
                                    ? _c("span", [
                                        _vm._v(
                                          " by " +
                                            _vm._s(_vm.review.accepted_by_email)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.review.accepted_sequence
                            ? [
                                _c("dt", { staticClass: "col-sm-4" }, [
                                  _vm._v("Results"),
                                ]),
                                _vm._v(" "),
                                _c("dd", { staticClass: "col-sm-8" }, [
                                  _vm._v(_vm._s(_vm.countsSummary(_vm.review))),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.review.warnings.length
                        ? _c(
                            "div",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "small font-weight-bold" },
                                [_vm._v("Warnings")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.review.warnings, function (warning) {
                                return _c(
                                  "div",
                                  { key: warning.code, staticClass: "small" },
                                  [
                                    _c(
                                      "b-badge",
                                      { attrs: { variant: "warning" } },
                                      [_vm._v(_vm._s(warning.count))]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.labelize(warning.code)) +
                                        "\n                    "
                                    ),
                                    warning.labels
                                      ? _c(
                                          "span",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  warning.labels
                                                    .map(
                                                      (l) =>
                                                        `${l.label} × ${l.count}`
                                                    )
                                                    .join(", ")
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.review.counts.skipped
                        ? _c(
                            "div",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "small font-weight-bold" },
                                [_vm._v("Skipped reasons")]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.review.skip_reasons || [],
                                function (reason) {
                                  return _c(
                                    "div",
                                    { key: reason.code, staticClass: "small" },
                                    [
                                      _c(
                                        "b-badge",
                                        { attrs: { variant: "danger" } },
                                        [_vm._v(_vm._s(reason.count))]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.labelize(reason.code)) +
                                          "\n                  "
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "p-0",
                                  attrs: { size: "sm", variant: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openRows(_vm.review)
                                    },
                                  },
                                },
                                [_vm._v("View skipped rows")]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.review.older_export
                        ? _c(
                            "b-alert",
                            {
                              staticClass: "py-2",
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                "\n                  Batch #" +
                                  _vm._s(
                                    _vm.review.older_export.newer_batch.id
                                  ) +
                                  " has a newer export date, " +
                                  _vm._s(
                                    _vm.formatUtc(
                                      _vm.review.older_export.newer_batch
                                        .declared_export_at
                                    )
                                  ) +
                                  ".\n                  Applying this older file gives it precedence.\n                  "
                              ),
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    disabled: !_vm.canUpdate || _vm.busy,
                                  },
                                  model: {
                                    value: _vm.applyAcknowledged,
                                    callback: function ($$v) {
                                      _vm.applyAcknowledged = $$v
                                    },
                                    expression: "applyAcknowledged",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    I understand this file is an older export and still want to apply it.\n                  "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("details", { staticClass: "mb-3" }, [
                        _c("summary", [_vm._v("Source and audit details")]),
                        _c("pre", { staticClass: "registry-import-evidence" }, [
                          _vm._v(_vm._s(_vm.formatJson(_vm.review))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap align-items-center" },
                        [
                          _vm.review.available_actions.includes("apply")
                            ? _c(
                                "b-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    variant: "success",
                                    disabled:
                                      !_vm.canUpdate ||
                                      _vm.busy ||
                                      (_vm.review.older_export &&
                                        !_vm.applyAcknowledged),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.applyImport(_vm.review)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Apply\n                    "
                                  ),
                                  _vm.applying
                                    ? _c("b-spinner", {
                                        staticClass: "ml-1",
                                        attrs: { small: "" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.review.available_actions.includes("retry")
                            ? _c(
                                "b-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    variant: "outline-warning",
                                    disabled: !_vm.canUpdate || _vm.busy,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.retryImport(_vm.review, false)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.retryLabel(_vm.review)))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.review.available_actions.includes("revalidate")
                            ? _c(
                                "b-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    variant: "outline-warning",
                                    disabled: !_vm.canUpdate || _vm.busy,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.retryImport(_vm.review, true)
                                    },
                                  },
                                },
                                [_vm._v("Revalidate")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.review.status !== "rejected"
                            ? _c(
                                "b-btn",
                                {
                                  attrs: {
                                    variant: "outline-secondary",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openRows(_vm.review)
                                    },
                                  },
                                },
                                [_vm._v("Rows")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-3",
        },
        [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Import batches")]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.pollStopped
                ? _c("small", { staticClass: "text-danger mr-2" }, [
                    _vm._v("Auto-refresh stopped after an error."),
                  ])
                : _vm.pollTimer
                ? _c("small", { staticClass: "text-muted mr-2" }, [
                    _vm._v("Refreshing while work is active"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "outline-secondary",
                    disabled: _vm.importsLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.loadImports(_vm.importsMeta.current_page || 1)
                    },
                  },
                },
                [_vm._v("\n                Refresh\n              ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.importsError
        ? _c(
            "b-alert",
            { attrs: { show: "", variant: "danger" } },
            [
              _vm._v(_vm._s(_vm.importsError) + " "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.loadImports(_vm.importsPage)
                    },
                  },
                },
                [_vm._v("Retry")]
              ),
            ],
            1
          )
        : _c("b-table", {
            attrs: {
              items: _vm.imports,
              fields: _vm.importFields,
              busy: _vm.importsLoading && !_vm.imports.length,
              small: "",
              responsive: "",
              "show-empty": "",
              "empty-text": "No imports found.",
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c("p", { attrs: { role: "status" } }, [
                      _vm._v("Loading imports..."),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(file)",
                fn: function (row) {
                  return [
                    _c("strong", [_vm._v(_vm._s(row.item.original_file_name))]),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        _vm._s(_vm.labelize(row.item.dataset_kind)) +
                          " · Batch " +
                          _vm._s(row.item.batch_id)
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (row) {
                  return [
                    _c(
                      "b-badge",
                      { attrs: { variant: _vm.phaseVariant(row.item.phase) } },
                      [_vm._v(_vm._s(_vm.phaseLabel(row.item.phase)))]
                    ),
                    _vm._v(" "),
                    row.item.rejection
                      ? _c("div", { staticClass: "small text-danger" }, [
                          _vm._v(
                            _vm._s(_vm.readable(row.item.rejection.message))
                          ),
                        ])
                      : _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            _vm._s(_vm.readable(_vm.phaseDescription(row.item)))
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(progress)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n              " +
                        _vm._s(row.item.processed_row_count) +
                        " / " +
                        _vm._s(
                          row.item.row_count === null ? "?" : row.item.row_count
                        ) +
                        "\n            "
                    ),
                  ]
                },
              },
              {
                key: "cell(counts)",
                fn: function (row) {
                  return [
                    _c("small", [_vm._v(_vm._s(_vm.countsSummary(row.item)))]),
                  ]
                },
              },
              {
                key: "cell(warnings)",
                fn: function (row) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: row.item.warnings
                            .map((w) => `${w.code} × ${w.count}`)
                            .join("\n"),
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(row.item.counts.warnings) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(declared_export_at)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          row.item.declared_export_at_local || "Not supplied"
                        ) +
                        "\n            "
                    ),
                  ]
                },
              },
              {
                key: "cell(actor)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          row.item.initiated_by_email ||
                            row.item.initiated_by_user_id ||
                            "System"
                        ) +
                        "\n            "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    _c(
                      "b-btn",
                      {
                        staticClass: "mr-1",
                        attrs: { size: "sm", variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.openReview(row.item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              row.item.available_actions.includes("apply")
                                ? "Review"
                                : "Details"
                            ) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        staticClass: "mr-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-secondary",
                          disabled: row.item.status === "rejected",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openRows(row.item)
                          },
                        },
                      },
                      [_vm._v("Rows")]
                    ),
                    _vm._v(" "),
                    row.item.available_actions.includes("retry")
                      ? _c(
                          "b-btn",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              size: "sm",
                              variant: "outline-warning",
                              disabled: !_vm.canUpdate || _vm.busy,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.retryImport(row.item, false)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.retryLabel(row.item)))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    row.item.available_actions.includes("revalidate")
                      ? _c(
                          "b-btn",
                          {
                            attrs: {
                              size: "sm",
                              variant: "outline-warning",
                              disabled: !_vm.canUpdate || _vm.busy,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.retryImport(row.item, true)
                              },
                            },
                          },
                          [_vm._v("Revalidate")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
      _vm._v(" "),
      _vm.importsMeta.total
        ? _c("b-pagination", {
            key: _vm.importsRequest,
            attrs: {
              value: _vm.importsPage,
              "total-rows": _vm.importsMeta.total,
              "per-page": _vm.importsMeta.per_page || 25,
              align: "center",
            },
            on: { input: _vm.loadImports },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.rowsBatch
              ? `Rows of batch #${_vm.rowsBatch.batch_id}`
              : "Rows",
            size: "xl",
            "hide-footer": "",
          },
          model: {
            value: _vm.rowsModalVisible,
            callback: function ($$v) {
              _vm.rowsModalVisible = $$v
            },
            expression: "rowsModalVisible",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Results" } },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: { options: _vm.rowResultOptions },
                        on: {
                          change: function ($event) {
                            return _vm.loadRows(1)
                          },
                        },
                        model: {
                          value: _vm.rowsFilter,
                          callback: function ($$v) {
                            _vm.rowsFilter = $$v
                          },
                          expression: "rowsFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.rowsError
            ? _c(
                "b-alert",
                { attrs: { show: "", variant: "danger" } },
                [
                  _vm._v(_vm._s(_vm.rowsError) + " "),
                  _c(
                    "b-btn",
                    {
                      attrs: { size: "sm", variant: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.loadRows(_vm.rowsPage)
                        },
                      },
                    },
                    [_vm._v("Retry")]
                  ),
                ],
                1
              )
            : _c("b-table", {
                attrs: {
                  items: _vm.rows,
                  fields: _vm.rowFields,
                  busy: _vm.rowsLoading,
                  small: "",
                  responsive: "",
                  "show-empty": "",
                  "empty-text": "No rows.",
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function () {
                      return [
                        _c("p", { attrs: { role: "status" } }, [
                          _vm._v("Loading rows..."),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(source_record_id)",
                    fn: function (row) {
                      return [
                        _vm._v(_vm._s(_vm.readable(row.item.source_record_id))),
                      ]
                    },
                  },
                  {
                    key: "cell(result)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-badge",
                          {
                            attrs: {
                              variant: _vm.rowResultVariant(row.item.result),
                            },
                          },
                          [_vm._v(_vm._s(row.item.result))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(reasons)",
                    fn: function (row) {
                      return _vm._l(row.item.reasons, function (reason, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "small" },
                          [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant:
                                    reason.level === "skip"
                                      ? "danger"
                                      : reason.level === "warning"
                                      ? "warning"
                                      : "light",
                                },
                              },
                              [_vm._v(_vm._s(reason.code))]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.readable(reason.message)) +
                                "\n          "
                            ),
                          ],
                          1
                        )
                      })
                    },
                  },
                  {
                    key: "cell(raw)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-btn",
                          {
                            attrs: { size: "sm", variant: "link" },
                            on: { click: row.toggleDetails },
                          },
                          [_vm._v(_vm._s(row.detailsShowing ? "Hide" : "Raw"))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "row-details",
                    fn: function (row) {
                      return [
                        _c(
                          "pre",
                          {
                            staticClass:
                              "bg-light border rounded p-2 mb-0 overflow-auto license-registry-json",
                          },
                          [
                            _c("code", [
                              _vm._v(_vm._s(_vm.formatJson(row.item.raw))),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
          _vm._v(" "),
          _vm.rowsMeta.total
            ? _c("b-pagination", {
                key: _vm.rowsRequest,
                attrs: {
                  value: _vm.rowsPage,
                  "total-rows": _vm.rowsMeta.total,
                  "per-page": _vm.rowsMeta.per_page || 50,
                  align: "center",
                },
                on: { input: _vm.loadRows },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }